"use client";

import { SegmentControl } from "@woba/ds-web-next";
import type { MyProductsViewToggleProps, ViewMode } from "../types";
import { useTranslation } from "react-i18next";

const isViewMode = (value: string): value is ViewMode =>
  value === "credits" || value === "currency";

/**
 * Alternância Crédito/Moeda no SegmentControl do Workbase DS (Figma 6038:3392).
 * O SegmentControl fixa `width: 100%` inline, então a largura vem do wrapper
 * (`className`): no Figma ele tem 240px no desktop e a largura toda no mobile.
 */
export function MyProductsViewToggle({
  mode,
  onChange,
  className,
}: MyProductsViewToggleProps) {
  const [translate] = useTranslation(["dashboard"]);

  return (
    <div className={className} data-testid="my-products-view-toggle">
      <SegmentControl
        accessibilityLabel={
          translate("dashboard-my-products-view-title") as string
        }
        value={mode}
        onValueChange={(value) => {
          if (isViewMode(value)) onChange(value);
        }}
        items={[
          {
            value: "credits",
            label: translate(
              "dashboard-my-products-view-toggle-credits",
            ) as string,
          },
          {
            value: "currency",
            label: translate(
              "dashboard-my-products-view-toggle-currency",
            ) as string,
          },
        ]}
      />
    </div>
  );
}
